export default __webpack_public_path__ + "static/media/shimla1.f80e0ba5.jpg";